import { useEffect, useMemo, useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import {
  Box,
  Button,
  ButtonGroup,
  IconButton,
} from '@mui/material';
import { Header } from '../../components/Header';
import { Page } from '../../components/Page';
import './style.scss';
import { useGetDieselOrdersQuery } from '../../core/redux/transport';
import { DieselOrderList } from './partials/DieselOrderList';
import { DieselCounter } from './partials/DieselCounter';
import { ShowPeriod } from '../../core/redux/orderFilter';

export const DieselTransportPage = () => {
  const [selection, setSelection] = useState<ShowPeriod>('Future');
  const [sortAsc, setSortAsc] = useState(true);

  const {
    data: orders,
    isLoading,
    isFetching,
    refetch,
  } = useGetDieselOrdersQuery(selection);

  const sortedOrders = useMemo(() => {
    if (!orders) return [];
    return [...orders].sort((a, b) => (sortAsc ? a.unix - b.unix : b.unix - a.unix));
  }, [orders, sortAsc]);

  useEffect(() => {
    refetch();
  }, []);

  return (
    <Page className="diesel-transport-page">
      <Header>Dieseltransport</Header>
      <div className="diesel-transport-wrapper">
        <div className="diesel-transport-area">
          <DieselCounter />

          <Box className="header" pt={1}>
            <span className="header-group">
              <ButtonGroup fullWidth variant="contained" aria-label="outlined primary button group">
                <Button
                  variant={selection === 'Future' ? 'contained' : 'outlined'}
                  onClick={() => setSelection('Future')}
                >
                  Fremtidige
                </Button>
                <Button
                  variant={selection === 'Last7Days' ? 'contained' : 'outlined'}
                  onClick={() => setSelection('Last7Days')}
                >
                  siste 7 dager
                </Button>
                <Button
                  variant={selection === 'Last14Days' ? 'contained' : 'outlined'}
                  onClick={() => setSelection('Last14Days')}
                >
                  siste 14 dager
                </Button>
                <Button
                  variant={selection === 'All' ? 'contained' : 'outlined'}
                  onClick={() => setSelection('All')}
                >
                  alle
                </Button>
              </ButtonGroup>
            </span>
            <IconButton aria-label="sort" onClick={() => setSortAsc(!sortAsc)}>
              {sortAsc ? <ArrowUpwardIcon /> : <ArrowDownwardIcon />}
            </IconButton>
            <span className="header-button">
              <ButtonGroup fullWidth aria-label="outlined create button">
                <Button onClick={() => window.open('/diesel/opprett')} variant="contained">
                  <AddIcon />
                </Button>
              </ButtonGroup>
            </span>
          </Box>

          <DieselOrderList
            days={sortedOrders}
            isLoading={isLoading || isFetching}
            showPeriod={selection}
          />
        </div>
      </div>
    </Page>
  );
};
